import type { HrefType } from '@/lib/analytics/event-catalog';
import { VA_EVENTS } from '@/lib/analytics/event-catalog';
import { vaTrack } from '@/lib/analytics/vercel-events';

export function classifyHrefType(href: string): HrefType {
  const trimmed = href.trim();
  if (!trimmed) return 'internal';

  const lower = trimmed.toLowerCase();
  if (lower.startsWith('tel:')) return 'tel';
  if (lower.startsWith('mailto:')) return 'mailto';
  if (lower.startsWith('#')) return 'anchor';

  if (lower.startsWith('http://') || lower.startsWith('https://')) {
    try {
      const url = new URL(trimmed);
      if (typeof window !== 'undefined' && url.origin === window.location.origin) {
        return 'internal';
      }
      return 'external';
    } catch {
      return 'external';
    }
  }

  return 'internal';
}

export function trackCtaClick({
  location,
  label,
  href,
  isLeadForm = false,
  variant,
}: {
  location: string;
  label: string;
  href: string;
  isLeadForm?: boolean;
  variant?: 'primary' | 'secondary';
}): void {
  vaTrack(VA_EVENTS.CTA_CLICK, {
    location,
    label: label.trim().slice(0, 255),
    href_type: classifyHrefType(href),
    is_lead_form: isLeadForm,
    variant: variant ?? null,
  });
}
